import { defineStore } from 'pinia'
import { markRaw, ref } from 'vue'

export const useIndoorviewStore = defineStore('indoorview', () => {
  // States
  const isIndoorviewCropActive = ref<boolean>(false)
  const isIndoorviewMeasurementActive = ref<boolean>(false)
  const isAssetsPanelActive = ref<boolean>(false)

  // API instances (replacing global exports)
  const ivApi = ref<any>(null)
  const ivInstance = ref<any>(null)
  const ivApi2 = ref<any>(null)
  const ivInstance2 = ref<any>(null)

  // Getters

  // Actions
  function setIsIndoorviewCropActive(isActive: boolean) {
    isIndoorviewCropActive.value = isActive
  }
  function setIsIndoorviewMeasurementActive(isActive: boolean) {
    isIndoorviewMeasurementActive.value = isActive
  }
  function setIsAssetsPanelActive(isActive: boolean) {
    isAssetsPanelActive.value = isActive
  }
  function setIvApi(api: any, instance: any) {
    // markRaw: the NavVis Ivion SDK instance is a large third-party object
    // (WebGL/observable internals) that mutates itself constantly during
    // crop/point-cloud operations. Letting Vue make it reactive means every
    // internal read/write goes through proxy traps, which pegs the main
    // thread when Ivion's native crop tool is used.
    ivApi.value = api ? markRaw(api) : api
    ivInstance.value = instance ? markRaw(instance) : instance
  }
  function setIvApi2(api: any, instance: any) {
    ivApi2.value = api ? markRaw(api) : api
    ivInstance2.value = instance ? markRaw(instance) : instance
  }

  return {
    isIndoorviewCropActive,
    isIndoorviewMeasurementActive,
    isAssetsPanelActive,
    ivApi,
    ivInstance,
    ivApi2,
    ivInstance2,
    setIsIndoorviewCropActive,
    setIsIndoorviewMeasurementActive,
    setIsAssetsPanelActive,
    setIvApi,
    setIvApi2
  }
})
